import React, { useState } from "react";
import { Layout } from "../../containers";
import { Container } from "./styled";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import firebase from "../../lib/fire";
import secureLocalStorage from "react-secure-storage";

function SuccessSuscription() {
  const [planInfo, setPlanInfo] = useState(null);
  const history = useHistory();
  const userLocal = secureLocalStorage.getItem("userLocal");
  const userLocalId = secureLocalStorage.getItem("userId");
  const location = useLocation();

  useEffect(async () => {
    const searchParams = new URLSearchParams(location.search);
    const payment_id = searchParams.get("payment_id");

    const plan_data = await getSubscription(payment_id);
    setPlanInfo(plan_data);
  }, []);

  async function getSubscription(planId) {
    const response = await fetch(
      `https://deportactico-vercel-serverless.vercel.app/api/subscription/${planId}`
    );
    const data = await response.json();
    return data.description;
  }
  const handleConfirmClick = () => {
    //UPDATE LOCAL STORAGE
    if (planInfo !== null && planInfo === "Deportactico Premium") {
      let userLocalBKP = userLocal;
      if (userLocalId !== null && userLocalId !== undefined) {
        var ref = firebase
          .database()
          .ref(`users/0/${userLocalId}`)
          .update({ plan: "Premium" })
          .then((snapshot) => {
            //UPDATE LOCAL STORAGE
            userLocalBKP.plan = "Premium";
            secureLocalStorage.setItem("userLocal", userLocalBKP);
            history.push("/app/main");
          });
      }
    }
  };
  return (
    <Layout>
      <Container>
        <div className="succes-pop-up">
          <h1>Gracias por suscribirte</h1>
          <p>
            Acabas de suscribirte al plan{" "}
            {planInfo !== null && planInfo !== undefined ? planInfo : null}.
            Esperamos que disfrutes las nuevas funcionalidades.
          </p>
          <a className="btn-primary" onClick={handleConfirmClick}>
            Ir a tu cuenta
          </a>
        </div>
      </Container>
    </Layout>
  );
}

export default SuccessSuscription;
